if(document.querySelector('.vidbg video')){



// hero video carousel — buffered, from-the-top switching
const vids=[...document.querySelectorAll('.vidbg video')],dots=[...document.querySelectorAll('.viddots span')];
let vi=0,vt,switching=false;
function showVid(n){
  if(switching)return;switching=true;
  const prev=vi;vi=((n%vids.length)+vids.length)%vids.length;
  const nv=vids[vi];
  const go=()=>{
    try{nv.currentTime=0}catch(e){}
    nv.play().catch(()=>{});
    nv.classList.add('on');dots[vi].classList.add('on');
    if(prev!==vi){vids[prev].classList.remove('on');dots[prev].classList.remove('on');
      setTimeout(()=>vids[prev].pause(),1500);}
    switching=false;
  };
  if(nv.readyState>=3){go()}
  else{nv.addEventListener('canplaythrough',go,{once:true});nv.load();
    setTimeout(()=>{if(switching){switching=false}},4000);}
}
function autoVid(){clearInterval(vt);vt=setInterval(()=>showVid(vi+1),9500)}
vids[0].play().catch(()=>{});autoVid();
// don't rotate while the hero is offscreen
new IntersectionObserver(es=>es.forEach(e=>{
  if(e.isIntersecting){vids[vi].play().catch(()=>{});autoVid()}
  else{clearInterval(vt);vids[vi].pause()}
}),{threshold:.1}).observe(document.querySelector('.hero'));
dots.forEach((d,n)=>d.onclick=()=>{showVid(n);autoVid()});


}
// header shrink + back-to-top
const hdr=document.getElementById('hdr'),topBtn=document.getElementById('top-btn');
addEventListener('scroll',()=>{
  hdr.classList.toggle('scrolled',scrollY>40);
  topBtn.classList.toggle('show',scrollY>600);
},{passive:true});
topBtn.onclick=()=>scrollTo({top:0,behavior:'smooth'});

// rotating announcement bar
const msgs=[...document.querySelectorAll('.annbar .msg')];let mi=0;
setInterval(()=>{msgs[mi].classList.remove('on');mi=(mi+1)%msgs.length;msgs[mi].classList.add('on')},4500);

// scroll reveal
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

if(document.getElementById('list')){
// the crypt awakens — fog rolls out when the section comes into view
const crypt=document.getElementById('list');
new IntersectionObserver((es,o)=>es.forEach(e=>{if(e.isIntersecting){crypt.classList.add('crypt-on');o.disconnect()}}),{threshold:.3}).observe(crypt);


}
// tabs
document.querySelectorAll('.tab').forEach(t=>t.onclick=()=>{
  document.querySelectorAll('.tab').forEach(x=>x.classList.remove('on'));
  document.querySelectorAll('.pane').forEach(x=>x.classList.remove('on'));
  t.classList.add('on');
  document.getElementById('pane-'+t.dataset.pane).classList.add('on');
});

// ===== REAL CART — Shopify checkout via cart permalink =====
const SHOP='';
let bag=[];
const cartBtn=document.querySelector('.cart'),drawerEl=document.getElementById('drawer');
function openCart(){document.body.classList.add('cart-open')}
function closeCart(){document.body.classList.remove('cart-open')}
cartBtn.onclick=openCart;
document.querySelector('.dclose').onclick=closeCart;
document.getElementById('dim').onclick=closeCart;
function money(n){return '$'+n.toFixed(2)}
function renderCart(){
  const box=document.getElementById('ditems');
  cartBtn.textContent='Cart · '+bag.reduce((s,i)=>s+i.qty,0);
  if(!bag.length){box.innerHTML='<p class="dempty">Nothing in the crypt yet.</p>';
    document.getElementById('dtotal').textContent='$0.00';
    document.getElementById('checkout').href='#';return}
  box.innerHTML=bag.map((i,n)=>`<div class="ditem"><img src="${i.img}" alt="">
    <div><div class="di-n">${i.name}</div><div class="di-v">${i.v} × ${i.qty}</div></div>
    <span class="di-p">${money(i.p*i.qty)}</span>
    <button class="di-x" data-n="${n}" aria-label="Remove">✕</button></div>`).join('');
  const total=bag.reduce((s,i)=>s+i.p*i.qty,0);
  document.getElementById('dtotal').textContent=money(total);
  document.getElementById('checkout').href=SHOP+'/cart/'+bag.map(i=>i.vid+':'+i.qty).join(',');
  box.querySelectorAll('.di-x').forEach(b=>b.onclick=()=>{bag.splice(+b.dataset.n,1);renderCart()});
}
function itemFromCard(card){
  const sel=card.querySelector('.vsel'),opt=sel.selectedOptions[0];
  return {vid:opt.value,v:opt.textContent,p:parseFloat(opt.dataset.p),
    name:card.dataset.name,img:card.querySelector('.pimg img').src,qty:1};
}
function fbWireCard(card){
  const sel=card.querySelector('.vsel');if(!sel)return;
  sel.onchange=()=>card.querySelector('.price').textContent='$'+sel.selectedOptions[0].dataset.p;
  card.querySelector('.addb').onclick=()=>{
    const it=itemFromCard(card);
    const ex=bag.find(b=>b.vid===it.vid);
    ex?ex.qty++:bag.push(it);
    renderCart();const ab=card.querySelector('.addb');ab.classList.add('ok');ab.textContent='\u2713 Bagged';setTimeout(()=>{ab.classList.remove('ok');ab.textContent='Add'},1200);cartBtn.classList.add('cart-bump');
    setTimeout(()=>cartBtn.classList.remove('cart-bump'),450);openCart()};
  card.querySelector('.buyb').onclick=()=>{
    const it=itemFromCard(card);
    location.href=SHOP+'/cart/'+it.vid+':1'};
}
window.fbWireCard=fbWireCard;document.querySelectorAll('.pcard').forEach(fbWireCard);

/* ===== V12: galleries + poster tilt ===== */
try{
function fbWireGallery(pi){
  const st=pi.querySelector('.pstrip');if(!st||st.children.length<2)return;
  pi.classList.add('multi');
  const dots=[...pi.querySelectorAll('.pdots s')];let cur=0;
  const W=()=>st.clientWidth||1;
  st.addEventListener('scroll',()=>{requestAnimationFrame(()=>{const i=Math.round(st.scrollLeft/W());if(i!==cur&&dots[i]){cur=i;dots.forEach((d,k)=>d.classList.toggle('on',k===i))}})},{passive:true});
  dots.forEach((d,i)=>d.addEventListener('click',e=>{e.preventDefault();st.scrollTo({left:i*W(),behavior:'smooth'})}));
  const pv=pi.querySelector('.pprev'),nx=pi.querySelector('.pnext');
  pv&&(pv.onclick=e=>{e.preventDefault();st.scrollBy({left:-W(),behavior:'smooth'})});
  nx&&(nx.onclick=e=>{e.preventDefault();st.scrollBy({left:W(),behavior:'smooth'})});
}
window.fbWireGallery=fbWireGallery;document.querySelectorAll('.pimg').forEach(fbWireGallery);
if(matchMedia('(hover:hover) and (pointer:fine)').matches&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
  document.querySelectorAll('.po-card').forEach(c=>{const s=c.querySelector('.po-sheet');if(!s)return;
    c.addEventListener('pointermove',e=>{const r=c.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;s.style.transform='rotateY('+(x*9)+'deg) rotateX('+(y*-9)+'deg)'});
    c.addEventListener('pointerleave',()=>{s.style.transform=''});
  });
}
}catch(err){console.warn('v12 extras',err)}

/* ===== V12.1: lightbox carousel ===== */
try{
const lbx=document.createElement('div');lbx.className='lbx';
lbx.innerHTML='<div class="lbx-name"></div><button class="lbx-x" aria-label="Close">\u2715</button><button class="lbx-nav lbx-prev" aria-label="Previous">\u2039</button><div class="lbx-strip"></div><button class="lbx-nav lbx-next" aria-label="Next">\u203a</button><div class="lbx-dots"></div>';
document.body.appendChild(lbx);
const lstrip=lbx.querySelector('.lbx-strip'),ldots=lbx.querySelector('.lbx-dots'),lname=lbx.querySelector('.lbx-name');
const LW=()=>lstrip.clientWidth||1;let ldl=[];
function lclose(){lbx.classList.remove('on');document.body.style.overflow=''}
lbx.querySelector('.lbx-x').onclick=lclose;
lbx.addEventListener('click',e=>{if(e.target===lbx)lclose()});
document.addEventListener('keydown',e=>{if(e.key==='Escape')lclose()});
lbx.querySelector('.lbx-prev').onclick=()=>lstrip.scrollBy({left:-LW(),behavior:'smooth'});
lbx.querySelector('.lbx-next').onclick=()=>lstrip.scrollBy({left:LW(),behavior:'smooth'});
lstrip.addEventListener('scroll',()=>{requestAnimationFrame(()=>{const i=Math.round(lstrip.scrollLeft/LW());ldl.forEach((d,k)=>d.classList.toggle('on',k===i))})},{passive:true});
function fbBindLbx(pi){
  pi.addEventListener('click',e=>{
    if(e.target.closest('.pnav')||e.target.closest('.pdots'))return;
    const imgs=[...pi.querySelectorAll('img')];if(!imgs.length)return;
    lstrip.innerHTML=imgs.map(im=>'<img src="'+im.src+'" alt="'+(im.alt||'').replace(/"/g,'&quot;')+'">').join('');
    ldots.innerHTML=imgs.length>1?imgs.map((_,i)=>'<s'+(i?'':' class="on"')+'></s>').join(''):'';
    ldl=[...ldots.children];
    ldl.forEach((d,i)=>d.onclick=()=>lstrip.scrollTo({left:i*LW(),behavior:'smooth'}));
    const card=pi.closest('.pcard');lname.textContent=(card&&card.dataset.name)||'';
    lbx.classList.add('on');document.body.style.overflow='hidden';
    const st=pi.querySelector('.pstrip');const idx=st?Math.round(st.scrollLeft/(st.clientWidth||1)):0;
    requestAnimationFrame(()=>lstrip.scrollTo({left:idx*LW()}));
  });
}
window.fbBindLbx=fbBindLbx;document.querySelectorAll('.pcard .pimg').forEach(fbBindLbx);
}catch(err){console.warn('v12 lbx',err)}

/* ===== V12.2: category rail + pages ===== */
try{
const rail=document.getElementById('rail'),railDim=document.getElementById('railDim'),railTab=document.getElementById('railtab');
const openRail=()=>{rail.classList.add('on');railDim.classList.add('on')};
const closeRail=()=>{rail.classList.remove('on');railDim.classList.remove('on')};
railTab.onclick=openRail;railDim.onclick=closeRail;
document.getElementById('railX').onclick=closeRail;
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeRail()});
rail.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeRail));
const PAGES={tshirts:'#tshirts',posters:'#posters',hats:'#hats',swim:'#swim',hoodies:'#hoodies',accessories:'#accessories',story:'#story',list:'#list'};
const ALLONLY=['#top','#vault'];
let curRoute='all';
function route(r){
  if(!(r==='all'||PAGES[r]))r='all';
  curRoute=r;
  rail.querySelectorAll('a').forEach(a=>a.classList.toggle('on',a.dataset.r===r));
  railTab.classList.toggle('active',r!=='all');
  const all=r==='all';
  ALLONLY.forEach(s=>{const el=document.querySelector(s);if(el)el.style.display=all?'':'none'});
  Object.keys(PAGES).forEach(k=>{const el=document.querySelector(PAGES[k]);if(!el)return;
    const show=all||k===r;
    el.style.display=show?'':'none';
    el.classList.remove('page-in');
    if(!all&&show){void el.offsetWidth;el.classList.add('page-in')}
  });
  window.scrollTo({top:0});
}
function onHash(){
  const h=location.hash;
  const m=h.match(/^#\/([a-z]+)$/);
  if(m){route(m[1]);return}
  if(h&&h.length>1){
    if(curRoute!=='all')route('all');
    const el=document.querySelector(h);
    if(el)setTimeout(()=>el.scrollIntoView({behavior:'smooth'}),60);
  }else if(curRoute!=='all'){route('all')}
}
window.addEventListener('hashchange',onHash);
if(location.hash)onHash();
}catch(err){console.warn('v12 rail',err)}

/* ===== V12.3: LIVE RACKS — every grid pulls straight from Shopify ===== */
const FB_FALLBACK={"poster-shirt-collection":[
{"title":"Sort of a Big Deal Skeleton T-Shirt | Funny Vintage News Anchor Graphic Tee","product_type":"T-Shirt","variants":[{"id":48412207808734,"title":"White / S","price":"29.99"},{"id":48412207841502,"title":"White / M","price":"29.99"},{"id":48412207874270,"title":"White / L","price":"29.99"},{"id":48412207907038,"title":"White / XL","price":"31.99"},{"id":48412207939806,"title":"White / 2XL","price":"31.99"}],"images":[{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260701205355-1f1758ef-926e-6b16-8617-92c70f8650a4.png?v=1783453267"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260701203216-1f1758bf-3447-6c66-9210-32360c560801.png?v=1783453268"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260701203216-1f1758bf-3485-63a4-86f5-a6ccf20f7295.png?v=1783453269"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260701203215-1f1758bf-2982-683a-a0c4-5a45d823a43f.png?v=1783453269"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260701203216-1f1758bf-2c1d-6dba-8b9f-e6e51ef08870.png?v=1783453270"}]},
{"title":"How Did Doug Get So Good At Hide And Seek — Skeleton Movie Poster Tee","product_type":"T-Shirt","variants":[{"id":48412208070878,"title":"White / S","price":"29.99"},{"id":48412208103646,"title":"White / M","price":"29.99"},{"id":48412208136414,"title":"White / L","price":"29.99"},{"id":48412208169182,"title":"White / XL","price":"31.99"},{"id":48412208201950,"title":"White / 2XL","price":"31.99"}],"images":[{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630212350-1f174c9f-d013-613a-94b0-326964d3cd22.png?v=1783384142"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630212350-1f174c9f-cb9f-64be-a7a2-b2623e5beb0c.png?v=1783384143"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630212350-1f174c9f-cb1c-673a-8992-1646891e4bf5.png?v=1783384144"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630212529-1f174ca3-7fd7-6474-bf25-9ec9d3f29b29.jpg?v=1783384145"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630212634-1f174ca5-e9b4-62e6-8506-b2623e5beb0c.jpg?v=1783384145"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/16191744034812077548_2048.jpg?v=1783384145"}]},
{"title":"Famous Bones \u201c I Warned Them About the Salt\u201d \u2014 Skeleton Beach Movie Poster Tee","product_type":"T-Shirt","variants":[{"id":48412208431326,"title":"White / S","price":"29.99"},{"id":48412208464094,"title":"White / M","price":"29.99"},{"id":48412208496862,"title":"White / L","price":"29.99"},{"id":48412208529630,"title":"White / XL","price":"31.99"},{"id":48412208562398,"title":"White / 2XL","price":"31.99"}],"images":[{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630190829-1f174b71-46a4-6f7c-99c7-9ec9d3f29b29.png?v=1783384156"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630192358-1f174b93-e387-66f6-a258-76b708675436.png?v=1783384157"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630191551-1f174b81-b945-6fa8-b7df-7a6ce465d34a.png?v=1783384158"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630192358-1f174b93-e306-6bc8-85b0-326964d3cd22.png?v=1783384158"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630191425-1f174b7e-8b5f-6be6-8a28-326964d3cd22.png?v=1783384159"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/1714692746650717181_2048.jpg?v=1783384159"}]},
{"title":"Famous Bones Skeleton Movie Poster Tee \u2014 \u201cYou Are My Best Single Serving Friend\u201d","product_type":"T-Shirt","variants":[{"id":48412208627934,"title":"White / S","price":"29.99"},{"id":48412208660702,"title":"White / M","price":"29.99"},{"id":48412208693470,"title":"White / L","price":"29.99"},{"id":48412208726238,"title":"White / XL","price":"31.99"},{"id":48412208759006,"title":"White / 2XL","price":"31.99"}],"images":[{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260626220236-1f171aab-dae1-66b4-955c-46dadc2c42c9.png?v=1783384162"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260626220214-1f171aab-0981-625e-96da-66d9a0df68b2.jpg?v=1783384163"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260626220216-1f171aab-1637-64d0-a6a3-66d9a0df68b2.jpg?v=1783384163"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260626220215-1f171aab-132b-6b42-a1d4-ca578bed0d0c.jpg?v=1783384164"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260626220216-1f171aab-17c9-64b0-9923-ca578bed0d0c.jpg?v=1783384166"}]},
{"title":"Famous Bones \u201cAnother Man\u2019s Dog\u201d Tee | Skeleton Assassin & Dog Movie Poster","product_type":"T-Shirt","variants":[{"id":48412208824542,"title":"White / S","price":"29.99"},{"id":48412208857310,"title":"White / M","price":"29.99"},{"id":48412208890078,"title":"White / L","price":"29.99"},{"id":48412208922846,"title":"White / XL","price":"31.99"},{"id":48412208955614,"title":"White / 2XL","price":"31.99"}],"images":[{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630174854-1f174abf-5f6b-6c52-a9dc-ae97bc8dd6c7.png?v=1783384168"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630174854-1f174abf-5e7d-6804-96b4-326964d3cd22.png?v=1783384169"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630174853-1f174abf-5a75-67e8-9e3a-1646891e4bf5.png?v=1783384169"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630174853-1f174abf-58fe-659a-9a58-0e5695a70434.png?v=1783384170"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630174854-1f174abf-5f7e-641a-9770-1646891e4bf5.png?v=1783384170"},{"src":"https://cdn.shopify.com/s/files/1/0795/3694/7422/files/20260630174854-1f174abf-5f41-656a-9f19-42d0084b881b.png?v=1783384171"}]}
]};
FB_FALLBACK["all-tees"]=FB_FALLBACK["poster-shirt-collection"];
const FB_LABELS={"all-tees":"The tee rack","the-horror-wing":"Horror","action-crime":"Action & Crime","cult-classics":"Cult Classics","funny-bones":"Funny Bones","anime":"Anime","holiday":"Holiday","hats":"The hat rack","swim-shorts":"The swim rack","hoodies":"The hoodie rack","accessories":"The extras reel","poster-shirt-collection":"The first run"};
function fbEsc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;')}
function fbName(t){
  t=String(t).replace(/^Famous Bones\s*/i,'').replace(/[\u201c\u201d"]/g,'').trim();
  t=t.split(/\s*[\u2014|]\s*/)[0].trim();
  return t||'Famous Bones';
}
function fbCard(p,d){
  var name=fbName(p.title);
  var vars=(p.variants||[]).filter(function(v){return v.available!==false});
  if(!vars.length)return '';
  var strip=null;
  if(vars.length&&String(vars[0].title).indexOf(' / ')>0){
    var f0=String(vars[0].title).split(' / ')[0];
    if(vars.every(function(v){return String(v.title).split(' / ')[0]===f0}))strip=f0;
  }
  var imgs=(p.images||[]).slice(0,6).map(function(im){return im.src||im.url}).filter(Boolean);
  var media;
  if(imgs.length>1){
    media='<div class="pstrip">'+imgs.map(function(u){return '<span class="ps"><img loading="lazy" src="'+u+'" alt="'+fbEsc(name)+' \u2014 Famous Bones"></span>'}).join('')
      +'</div><button class="pnav pprev" aria-label="Previous">\u2039</button><button class="pnav pnext" aria-label="Next">\u203a</button>'
      +'<div class="pdots">'+imgs.map(function(_,i){return '<s'+(i?'':' class="on"')+'></s>'}).join('')+'</div>';
  }else{
    media='<img loading="lazy" src="'+(imgs[0]||'')+'" alt="'+fbEsc(name)+' \u2014 Famous Bones">';
  }
  var opts=vars.map(function(v){
    var label=String(v.title);
    if(strip&&label.indexOf(strip+' / ')===0)label=label.slice(strip.length+3);
    return '<option value="'+String(v.id)+'" data-p="'+parseFloat(v.price).toFixed(2)+'">'+fbEsc(label)+'</option>';
  }).join('');
  return '<div class="pcard reveal d'+((d%4)+1)+'" data-name="'+fbEsc(name)+'">'
    +'<div class="pimg">'+media+'</div>'
    +'<div class="pinfo"><span class="name">'+fbEsc(name)+'</span><span class="price">$'+parseFloat(vars[0].price).toFixed(2)+'</span></div>'
    +'<div class="prow"><select class="vsel" aria-label="Size">'+opts+'</select><button class="addb">Add</button><button class="buyb">Buy Now</button></div></div>';
}
function fbEmpty(label){
  return '<div class="rack-empty"><div class="re-k">In the Darkroom</div><h3>'+fbEsc(label)+' is developing</h3><p>This rack opens soon \u2014 and the List hears about it before the dirt settles. No exceptions.</p><a class="btn btn-m" href="#list">Get Notified<span class="shine"></span></a></div>';
}
async function fbFetchRack(key){
  var url=key==='all-tees'?SHOP+'/products.json?limit=250':SHOP+'/collections/'+key+'/products.json?limit=100';
  var r=await fetch(url);
  if(!r.ok)throw new Error('rack '+key+' http '+r.status);
  var j=await r.json();
  var prods=j.products||[];
  if(key==='all-tees')prods=prods.filter(function(p){return /t-?shirt|tee/i.test(p.product_type||'')||/\btee\b|t-shirt/i.test(p.title||'')});
  return prods;
}
async function fbLoadRack(el){
  var key=el.dataset.rack,prods=null;
  try{prods=await fbFetchRack(key)}catch(e){prods=FB_FALLBACK[key]||[]}
  var html=prods.map(function(p,i){return fbCard(p,i)}).filter(Boolean).join('');
  if(!html){el.innerHTML=fbEmpty(FB_LABELS[key]||'This rack');return 0}
  el.innerHTML=html;
  el.querySelectorAll('.pcard').forEach(function(c){try{fbWireCard(c)}catch(e){}});
  el.querySelectorAll('.pimg').forEach(function(pi){
    try{window.fbWireGallery&&window.fbWireGallery(pi)}catch(e){}
    try{window.fbBindLbx&&window.fbBindLbx(pi)}catch(e){}
  });
  el.querySelectorAll('.reveal').forEach(function(x){x.classList.add('in')});
  var n=el.querySelectorAll('.pcard').length;
  if(key==='poster-shirt-collection'&&n>0){
    var f=document.getElementById('po-fallback');if(f)f.style.display='none';
    el.style.display='';
  }
  return n;
}
(async function(){
  var grids=[].slice.call(document.querySelectorAll('[data-rack]'));
  var counts={};
  await Promise.all(grids.map(async function(g){counts[g.dataset.rack]=await fbLoadRack(g)}));
  document.querySelectorAll('[data-cnt]').forEach(function(s){
    var c=counts[s.dataset.cnt];
    if(c>0)s.textContent=c;else if(c===0)s.textContent='SOON';
  });
  document.querySelectorAll('.vcard p[data-sub]').forEach(function(p){
    var c=counts[p.dataset.sub],card=p.closest('.vcard');
    if(c>0){p.textContent=c+(c===1?' cut':' cuts')+' on the rack'}
    else if(c===0&&card){
      if(!card.querySelector('.soon')){var b=document.createElement('span');b.className='soon';b.textContent='SOON';card.appendChild(b)}
      var go=card.querySelector('.go');
      if(go&&go.firstChild)go.firstChild.textContent='Get Notified ';
      card.setAttribute('href','#list');
    }
  });
})();

/* ===== V12.3: THE KEEPER — coupon catch popup + real crypt capture ===== */
(function(){
var KP_CODE='CRYPT10';
function joinCrypt(email){
  try{
    var b=new URLSearchParams();
    b.set('form_type','customer');b.set('utf8','\u2713');
    b.set('contact[email]',email);b.set('contact[tags]','newsletter,crypt-list');
    fetch(SHOP+'/contact',{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:b.toString()});
  }catch(e){}
  try{localStorage.setItem('fbCryptJoined','1')}catch(e){}
}
function codeBlock(){
  return '<div class="kp-reveal"><p class="kp-won">\ud83c\udf9f The keeper honors his deals.</p><div class="kp-code"><span>'+KP_CODE+'</span><button class="kp-copy" type="button">Copy</button></div><p class="kp-fine">10% off your first order \u00b7 paste it at checkout</p></div>';
}
function wireReveal(scope){
  var btn=scope.querySelector('.kp-copy');
  if(btn)btn.onclick=function(){
    try{navigator.clipboard&&navigator.clipboard.writeText(KP_CODE)}catch(e){}
    btn.textContent='\u2713 Copied';setTimeout(function(){btn.textContent='Copy'},1400);
  };
}
var tf=document.querySelector('.crypt-form');
if(tf)tf.addEventListener('submit',function(e){
  e.preventDefault();
  var inp=tf.querySelector('input[type=email]');
  var em=inp?inp.value.trim():'';if(!em)return;
  joinCrypt(em);
  var holder=tf.parentElement;
  tf.outerHTML=codeBlock();
  wireReveal(holder);
});
var kpShown=false;
function kpSeen(){try{return localStorage.getItem('fbKeeperSeen')||localStorage.getItem('fbCryptJoined')}catch(e){return '1'}}
function showKeeper(){
  if(kpShown||kpSeen())return;kpShown=true;
  try{localStorage.setItem('fbKeeperSeen','1')}catch(e){}
  var w=document.createElement('div');w.className='keeper-pop';
  w.innerHTML='<div class="kp-card" role="dialog" aria-modal="true" aria-label="The crypt keeper has an offer">'
    +'<div class="kp-fog" aria-hidden="true"><i></i><i></i></div>'
    +'<button class="kp-x" aria-label="Close">\u2715</button>'
    +'<div class="kp-skull">\ud83d\udc80</div>'
    +'<div class="kp-k">\u00b7 The keeper stirs \u00b7</div>'
    +'<h2>Leaving so soon?</h2>'
    +'<p>The keeper trades in bones and bargains. Leave your name, take <b>10% off</b> your first order \u2014 and hear about drops before the dirt settles.</p>'
    +'<form class="kp-form"><input type="email" placeholder="your@email.com" required aria-label="Email"><button class="btn btn-m" type="submit">Strike the Deal<span class="shine"></span></button></form>'
    +'<button class="kp-no" type="button">The keeper remembers\u2026 but fine</button>'
    +'</div>';
  document.body.appendChild(w);
  requestAnimationFrame(function(){requestAnimationFrame(function(){w.classList.add('on')})});
  function close(){w.classList.remove('on');setTimeout(function(){w.remove()},380)}
  w.querySelector('.kp-x').onclick=close;
  w.querySelector('.kp-no').onclick=close;
  w.addEventListener('click',function(e){if(e.target===w)close()});
  document.addEventListener('keydown',function esc(e){if(e.key==='Escape'){close();document.removeEventListener('keydown',esc)}});
  var f=w.querySelector('.kp-form');
  f.addEventListener('submit',function(e){
    e.preventDefault();
    var em=f.querySelector('input').value.trim();if(!em)return;
    joinCrypt(em);
    var card=w.querySelector('.kp-card');
    card.querySelector('h2').textContent='The deal is struck.';
    var pp=card.querySelector('p');if(pp)pp.remove();
    var no=card.querySelector('.kp-no');if(no)no.remove();
    f.outerHTML=codeBlock();
    wireReveal(card);
  });
  setTimeout(function(){var i=w.querySelector('input');if(i)i.focus()},450);
}
setTimeout(showKeeper,16000);
addEventListener('scroll',function kpsc(){
  var d=document.documentElement;
  if((scrollY+innerHeight)/(d.scrollHeight||1)>0.45){showKeeper();removeEventListener('scroll',kpsc)}
},{passive:true});
document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0)showKeeper()});
})();


/* ===== V12.4: crypt lightning ===== */
(function(){
var list=document.getElementById('list');if(!list)return;
var zap=document.createElement('div');zap.className='crypt-zap';zap.setAttribute('aria-hidden','true');
list.appendChild(zap);
var mq=matchMedia('(prefers-reduced-motion: reduce)');
function strike(){
  if(!mq.matches&&list.classList.contains('crypt-on')){
    zap.classList.remove('zap');void zap.offsetWidth;zap.classList.add('zap');
  }
  setTimeout(strike,6000+Math.random()*12000);
}
setTimeout(strike,4500+Math.random()*4000);
})();


/* ===== V12.5: the descent — fog thickens as you go down ===== */
(function(){
var el=document.createElement('div');el.id='fogOmbre';el.setAttribute('aria-hidden','true');
el.innerHTML='<b class="fo1"></b><b class="fo2"></b><b class="fo3"></b>';
document.body.appendChild(el);
var ticking=false;
function upd(){
  var d=document.documentElement;
  var max=(d.scrollHeight-innerHeight)||1;
  var p=Math.min(1,Math.max(0,(window.scrollY||d.scrollTop||0)/max));
  var o=Math.pow(p,1.5);
  el.style.opacity=o.toFixed(3);
  el.style.transform='translateY('+((1-p)*24).toFixed(2)+'vh)';
  ticking=false;
}
addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd)}},{passive:true});
addEventListener('resize',function(){if(!ticking){ticking=true;requestAnimationFrame(upd)}},{passive:true});
upd();
})();

